import { Component, OnInit } from '@angular/core';
import { User } from '../shared/models/user';
import { UserService } from '../shared/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as AOS from 'aos';
declare var $: any;

@Component({
  selector: 'app-ourteamdetail',
  templateUrl: './ourteamdetail.component.html',
  styleUrls: ['./ourteamdetail.component.css']
})
export class OurteamdetailComponent implements OnInit {

  users: User;
  constructor(
    private service: UserService,
    public router: Router,
    private activeRoute: ActivatedRoute,
  ) { }

  async ngOnInit() {
    AOS.init();
    this.topposition();

    await this.activeRoute.params.subscribe(routeParams => {
      this.service.getUserById(routeParams.id).then(userData => {
        this.users = userData[0];
        console.log(this.users);
      })
    });
  }

  //scroll to top of the page automatically
  topposition() {
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
  }


  // getUserDetails(): void {
  //   this.activeRoute.params.subscribe(routeParams => {

  //     this.dataService.getCustomerDetails(routeParams.id).subscribe(

  //       (customerDetails: CustomerDetails) => {
  //         this.customerDetails = customerDetails;
  //         console.log(customerDetails);
  //       });

  //   });

  // }
}
